import { Component } from "react";
import { appContext } from "../../../AppContext";
import IbssSvgIcon from "../../Icons/SvgIcon/IbssSvgIcon";
import { Icons } from "../../../Common/AllsvgIcons";
import IbssDialog from "../../Dialogs/BaseDialog/IbssDialog";
import { Box, Divider, Typography } from "@mui/material";
import IbssButtonRedo from "../../Buttons/Button/IbssButton";
import { Button } from '@mui/material';
import { isEqual } from "lodash";
import IbssHorizontalTabs, { TabsParameters } from "../../Layout/Tabs/IbssTabs";
import EmployeeTabView from "./EmployeeTabView";
import VisitorTabView from "./VisitorTabView";
import IbssAvatar from "../../Miscellaneous/Avatar/IbssAvatar";
import { IDelegate } from "../../../Providers.Api/Delegates/GetManyByDelegatorEndpoint";
import IbssCheckBox from "../../Inputs/CheckBox/IbssCheckBox";
import "./EmployessOrVisitor.scss";
import * as UserPickerModule from "../../Inputs/UserPicker/UserPicker";
import React from "react";
import { rights } from "../../../Common/RightsManager";

export default class EmployeeOrVisitorPicker extends Component<IProps, IState>
{
    private get labels() { return appContext().labels; }
    private get apiClient() { return appContext().apiClient; }
    private get local() { return appContext().localStorageProvider; }

    constructor(props: IProps)
    {
        super(props);

        this.state = {
            showModal: false,
            isVisitor: false,
            noOnBehalfOfSelectedError: '',
            onBehalfOfUser: '',
            nonVisitorOnBehalfOfData: { email: "", firstName: "", lastName: "", company: "", displayName: "" },
            alreadyPresentError: '',
            visitorOnBehalfOfData: { email: "", firstName: "", lastName: "", company: "", visitorTypeId: '' },
            isValid: false,
            isVisitorValid: false,
            isEmployeeValid: false,
            bookingAutoCheckin: false,
            onBehalfOf: '',
            onBehalfOfData: { email: "", firstName: "", lastName: "", company: "", isVisitor: false, visitorTypeId: '' },
            useOnBehalfOfCostCodes: 0,
            selectedUser: '',
            visitorTypeTabIndex: 0
        }
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState): void
    {
        if (this.state.showModal && !isEqual(this.state.showModal, prevState.showModal))
        {
            this.setState({
                onBehalfOfUser: this.props.onBehalfOfData?.email || this.props.firstNameData || '',
            });
        }

        if (this.props.onBehalfOfData && !isEqual(prevProps?.onBehalfOfData, this.props?.onBehalfOfData))
        {
            this.setState({
                onBehalfOfData: this.props.onBehalfOfData,
                onBehalfOfUser: this.props.onBehalfOfData.email,
            });
        }
    }

    private handleVisitorFirstNameChange(value: string): void
    {
        this.setState({
            visitorOnBehalfOfData: {
                ...this.state.visitorOnBehalfOfData,
                firstName: value,
            },
            noOnBehalfOfSelectedError: ""
        });
    }

    private handleVisitorLastNameChange(value: string): void
    {
        this.setState({
            visitorOnBehalfOfData: {
                ...this.state.visitorOnBehalfOfData,
                lastName: value,
            },
            noOnBehalfOfSelectedError: ""
        });
    }

    private handleVisitorCompanyChange(value: string): void
    {
        this.setState({
            visitorOnBehalfOfData: {
                ...this.state.visitorOnBehalfOfData,
                company: value,
            },
            noOnBehalfOfSelectedError: ""
        });
    }

    private handleVisitorEmailChange(value: string): void
    {
        this.setState({
            visitorOnBehalfOfData: {
                ...this.state.visitorOnBehalfOfData,
                email: value,
            },
            noOnBehalfOfSelectedError: ""
        });
    }

    private handleVisitorTypeChange(value: string): void
    {
        this.setState({
            visitorOnBehalfOfData: {
                ...this.state.visitorOnBehalfOfData,
                visitorTypeId: value,
            },
            noOnBehalfOfSelectedError: ""
        });
    }

    private handleVisitorValidate(isValid: boolean): void
    {
        this.setState({ isValid: isValid, isVisitorValid: isValid })
    }

    private handleOnBehalfOfCostCodesClick(e: React.ChangeEvent<HTMLInputElement>): void
    {
        this.setState({
            useOnBehalfOfCostCodes: e.target.checked ? 1 : 0
        });
    }

    private handleOnBehalfOfAutoCheckinClick(e: React.ChangeEvent<HTMLInputElement>): void
    {
        this.setState({ bookingAutoCheckin: !this.state.bookingAutoCheckin });
    }

    private async handleSave(): Promise<void>
    {
        if (!this.state.isValid)
        {
            this.setState({ noOnBehalfOfSelectedError: this.labels.HubLabelNoOnBehalfSelcted });
            return;
        }

        const isVisitor = (this.state.visitorTypeTabIndex == 1 || this.props.forVisitor == true);
        if (!isVisitor)
        {
            await this.setState({
                onBehalfOf: this.state.nonVisitorOnBehalfOfData.email,
                onBehalfOfUser: this.state.nonVisitorOnBehalfOfData.email,
                selectedUser: this.state.nonVisitorOnBehalfOfData.email,
                onBehalfOfData:
                {
                    email: this.state.nonVisitorOnBehalfOfData.email,
                    firstName: this.state.nonVisitorOnBehalfOfData.firstName,
                    lastName: this.state.nonVisitorOnBehalfOfData.lastName,
                    company: this.state.nonVisitorOnBehalfOfData.company,
                    isVisitor: false,
                    visitorTypeId: '',
                },
                visitorOnBehalfOfData: { email: "", firstName: "", lastName: "", company: "", visitorTypeId: '' },
            });
        }
        else
        {
            await this.setState({
                onBehalfOf: this.state.visitorOnBehalfOfData.email,
                onBehalfOfUser: this.state.visitorOnBehalfOfData.email,
                selectedUser: this.state.visitorOnBehalfOfData.email,
                onBehalfOfData:
                {
                    email: this.state.visitorOnBehalfOfData.email,
                    firstName: this.state.visitorOnBehalfOfData.firstName,
                    lastName: this.state.visitorOnBehalfOfData.lastName,
                    company: this.state.visitorOnBehalfOfData.company,
                    isVisitor: true,
                    visitorTypeId: this.state.visitorOnBehalfOfData.visitorTypeId,
                },
                nonVisitorOnBehalfOfData: { email: "", firstName: "", lastName: "", company: "", displayName: "" },
            });
        }

        this.handleClose();
        this.props.onSubmit(this.state.onBehalfOf, this.state.onBehalfOfData, this.state.bookingAutoCheckin, this.state.useOnBehalfOfCostCodes);
        this.props.onConfirmBookingForOthers?.();
    }

    private handleClose(): void
    {
        this.setState({ showModal: false });
        this.setState({
            noOnBehalfOfSelectedError: "",
            onBehalfOfUser: this.state.showModal === false ? this.state.onBehalfOfUser : "",
            onBehalfOf: this.state.showModal === false ? this.state.onBehalfOf : "",
        })
    };

    private async handleFavouriteClick(selectedFavourite: IFavouriteUser): Promise<void>
    {
        this.setState({ onBehalfOfUser: selectedFavourite.email });
    }

    private async handleDelegateClick(selectedDelegate: IDelegate): Promise<void>
    {
        this.setState({ onBehalfOfUser: selectedDelegate.PrimaryEmail ?? "" });
    }

    private async handleEmployeeChange(employee: UserPickerModule.IUser | null): Promise<void>
    {
        if (employee)
        {
            this.setState({
                nonVisitorOnBehalfOfData: {
                    email: employee.email,
                    firstName: employee.firstName,
                    lastName: employee.lastName,
                    company: employee.company,
                    displayName: employee.displayName
                },
                noOnBehalfOfSelectedError: "",
                isValid: true,
                isEmployeeValid: true,
            })
        }
        else
        {
            this.setState({
                nonVisitorOnBehalfOfData: {
                    email: "",
                    firstName: "",
                    lastName: "",
                    company: "",
                    displayName: ""
                },
                isValid: false,
                isEmployeeValid: false,
            })
        }
    }

    private handleEmployeeVisitorTabChange(tabIndex: number): void
    {
        this.setState({ visitorTypeTabIndex: tabIndex });
        this.setState({ isValid: (tabIndex == 1 ? this.state.isVisitorValid : this.state.isEmployeeValid) });
    }

    public render(): JSX.Element
    {
        const hasOnBehalfAutoCheckinRights = rights.API.Bookings.BookOnBehalfAutoCheckinOption.has(this.props.buildingId);

        const tabs: TabsParameters[] = [
            {
                label: this.labels.HubLabelEmployee,
                components: (
                    <>
                        <EmployeeTabView
                            employeeName={this.state.onBehalfOfUser|| ""}
                            onChange={async text => this.setState({ onBehalfOfUser: text })}
                            onEmployeeChange={employee => this.handleEmployeeChange(employee)}
                            error={this.state.alreadyPresentError}
                        />
                        <div className="text-danger">{this.state.noOnBehalfOfSelectedError && this.state.noOnBehalfOfSelectedError}</div>
                        {hasOnBehalfAutoCheckinRights &&
                            <Box sx={{ my: 2, display: "flex", justifyContent: "center" }}>
                                <IbssCheckBox
                                    label={this.labels.HubLabelEmployeeAutoCheckInRoamerAccess}
                                    disabled={this.state.nonVisitorOnBehalfOfData.email === ""}
                                    checked={this.state.bookingAutoCheckin}
                                    onClicked={(e: React.ChangeEvent<HTMLInputElement>) => this.handleOnBehalfOfAutoCheckinClick(e)}
                                />
                            </Box>
                        }
                        <Box sx={{ my: 2, display: "flex", justifyContent: "center" }}>
                            <IbssCheckBox
                                label={this.labels.HubLabelEmployeeDefaultCostCodesForBooking}
                                checked={this.state.useOnBehalfOfCostCodes === 1}
                                disabled={this.state.nonVisitorOnBehalfOfData.email === "" && this.state.useOnBehalfOfCostCodes === 0}
                                onClicked={(e: React.ChangeEvent<HTMLInputElement>) => this.handleOnBehalfOfCostCodesClick(e)}
                            />
                        </Box>
                    </>
                ),
                tabButtonHeight: "40px",
            },
            {
                label: this.labels.HubLabelvisitor,
                components: (
                    <>
                        <VisitorTabView
                            buildingId={this.props.buildingId}
                            firstName={this.state.visitorOnBehalfOfData.firstName}
                            onFirstNameChange={e => this.handleVisitorFirstNameChange(e)}
                            lastName={this.state.visitorOnBehalfOfData.lastName}
                            onLastNameChange={e => this.handleVisitorLastNameChange(e)}
                            company={this.state.visitorOnBehalfOfData.company}
                            onCompanyChange={e => this.handleVisitorCompanyChange(e)}
                            email={this.state.visitorOnBehalfOfData.email}
                            onEmailChange={e => this.handleVisitorEmailChange(e)}
                            visitorTypeId={this.state.visitorOnBehalfOfData.visitorTypeId}
                            onVisitorTypeChange={e => this.handleVisitorTypeChange(e)}
                            onValidate={e => this.handleVisitorValidate(e)}
                        />
                        <div className="text-danger">{this.state.noOnBehalfOfSelectedError && this.state.noOnBehalfOfSelectedError}</div>
                        {rights.API.Bookings.BookOnBehalfAutoCheckinOption.has(this.props.buildingId) &&
                            <Box sx={{ my: 2, display: "flex", justifyContent: "center" }}>
                                <IbssCheckBox
                                    label={this.labels.HubLabelVisitorAutoCheckInRoamerAccess}
                                    checked={this.state.bookingAutoCheckin}
                                    onClicked={(e: React.ChangeEvent<HTMLInputElement>) => this.handleOnBehalfOfAutoCheckinClick(e)}
                                />
                            </Box>
                        }
                    </>
                ),
                tabButtonHeight: "40px",
            },
        ];

        const delegateTabs: TabsParameters[] = [
            {
                label: this.labels.HubLabelFavourites,
                components: (
                    <Box className="someone-else-delegated-tab">
                        {this.props.favourites &&
                            this.props.favourites.map((item) => (
                                <>
                                    <Box display={'flex'} alignItems={'center'} my={3} className="pointer" onClick={() => this.handleFavouriteClick(item)}>
                                        <IbssAvatar fullName={`${item.firstName} ${item.lastName}`} />
                                        <Typography pl={2}>{`${item.firstName} ${item.lastName}`}</Typography>
                                    </Box>
                                </>
                            ))}
                    </Box>
                ),
                tabButtonHeight: "40px",
            },
            {
                label: this.labels.HubLabelDelegatedBy,
                components: (
                    <Box className="someone-else-delegated-tab">
                        {this.props.delegatedBy &&
                            this.props.delegatedBy.map((item) => (
                                <>
                                    <Box display={'flex'} alignItems={'center'} my={3} className="pointer" onClick={() => this.handleDelegateClick(item)}>
                                        <IbssAvatar fullName={item.PrimaryDisplayName ? item.PrimaryDisplayName : ""} />
                                        <Typography pl={2}>{item.PrimaryDisplayName}</Typography>
                                    </Box>
                                </>
                            ))}
                    </Box>
                ),
                tabButtonHeight: "40px",
            },
        ];

        const employeeTabs = tabs.filter((item) => item.label === "Employee");
        const visitorTabs = tabs.filter((item) => item.label === this.labels.HubLabelvisitor);
        const delegatedTabs = delegateTabs.filter((item) => item.label === "Delegated By");

        return (
            <>
                <Button
                    disabled={this.props.disabled}
                    fullWidth
                    sx={{ justifyContent: 'space-between', display: 'flex', textTransform: 'capitalize', cursor: 'pointer' }}
                    className="mt-1"
                    onClick={() => this.setState({ showModal: true })}>
                        <Box className="space-text-item col-text icon-text-inline pl-0" sx={{ whiteSpace: 'nowrap' }}>
                            <IbssSvgIcon fontSize='small' className="mr-2">
                                {Icons.UserIcon}
                            </IbssSvgIcon>
                            {this.props.forVisitor == true ? this.labels.funcBookForAVistor_S : this.labels.HubLabelBookForSomeone}
                        </Box>
                    <Box className="d-flex" style={{ width: '38%', justifyContent: 'right', alignItems: 'center' }}>
                        <Box width={'100%'} display={'flex'} justifyContent={"space-between"} alignItems={'center'}>
                            <Box sx={{ width: 'calc(100% - 28px);' }}>

                                <Box sx={{ width: 'calc(100% - 28px);' }}>
                                    <Typography variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }} noWrap>
                                    {this.props.bookingOwnerName}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ lineHeight: '1' }}>
                                <IbssSvgIcon fontSize='medium' className="" sx={{ color: (theme) => theme.palette.text.primary }}>
                                    {Icons.RightArrowIcon}
                                </IbssSvgIcon>
                            </Box>
                        </Box>
                    </Box>
                </Button>
                <Divider className="my-1" />
                {
                    this.state.showModal &&
                    <IbssDialog
                        aria-modal="true"
                        aria-label="book on behalf of modal"
                        open={this.state.showModal}
                        fullWidth
                        header=
                        {
                            <>
                                <label className="modal-heading">{this.labels.HubLabelBookOnBehalfHeading}</label>
                            </>
                        }
                        dialogContent=
                        {
                            <Box>

                                <div className="d-flex justify-content-between">
                                    <label className="lable-modal">{this.labels.HubLabelChooseBookingSpaceFor}</label>
                                    {/* <input name="isPrivate" type="checkbox" className="input-check-box-label border checkbox-sm" checked={this.state.isVisitor} onChange={() => this.handleChangeVisitor()} /> */}
                                </div>
                                <div className="mb-3">
                                    <IbssHorizontalTabs
                                        defaultValue={this.state.visitorTypeTabIndex}
                                        tabChanged={tabIndex => this.handleEmployeeVisitorTabChange(tabIndex)}
                                        tabs={this.props.forVisitor ? visitorTabs : rights.API.Bookings.BookOnBehalfOf.has() ? tabs : employeeTabs}
                                        orientation="horizontal"
                                        boxwidth='100%'
                                    />
                                </div>
                                {(rights.API.Bookings.V2.has() && this.props.delegatedBy) && this.props.forVisitor != true &&
                                    <div className="mb-2">
                                        <IbssHorizontalTabs
                                            tabs={rights.API.Bookings.BookOnBehalfOf.has() ? delegateTabs : delegatedTabs}
                                            className="someone-else-delegated-tab"
                                            orientation="horizontal"
                                            boxwidth='100%'
                                        />
                                    </div>
                                }
                            </Box>
                        }
                        footer=
                        {
                            <div className="px-58 w-100 d-flex justify-content-center btn-block">
                                <IbssButtonRedo
                                    variant='contained'
                                    sx={{ width: '50%', ml: 0.5 }}
                                    onClick={() => this.handleSave()}
                                    disabled={!this.state.isValid}
                                >
                                    {this.labels.HubButtonSave}
                                </IbssButtonRedo>
                            </div>
                        }
                        onClose={() => this.handleClose()}
                    />
                }
            </>
        );
    }
}

export interface IState
{
    showModal: boolean;
    isVisitor: boolean;
    noOnBehalfOfSelectedError: string;
    onBehalfOfUser: string;
    nonVisitorOnBehalfOfData: INonVisitorOnBehalfOfData;
    alreadyPresentError: string;
    visitorOnBehalfOfData: IVisitorOnBehalfOfData;
    isValid: boolean;
    isVisitorValid: boolean;
    isEmployeeValid: boolean;
    bookingAutoCheckin: boolean;
    onBehalfOf: string;
    onBehalfOfData: IOnBehalfOf;
    useOnBehalfOfCostCodes: number;
    selectedUser: string;
    visitorTypeTabIndex: number;
}

export interface IProps
{
    onBehalfOfData?: IOnBehalfOf;
    firstNameData?: string;
    bookingOwnerName?: string
    delegatedBy?: IDelegate[] | undefined;
    favourites?: IFavouriteUser[] | undefined;
    BookingId?: string;
    buildingId: number;
    disabled?: boolean;
    forVisitor?: boolean;
    onSubmit: (onBehalfOf: string, onBehalfOfData: IOnBehalfOf, bookingAutoCheckin: boolean, useOnBehalfOfCostCodes: number) => void;
    onConfirmBookingForOthers?: () => void;
}

export interface IFavouriteUser
{
    email: string;
    firstName: string;
    lastName: string;
}

export interface INonVisitorOnBehalfOfData
{
    email: string;
    firstName: string;
    lastName: string;
    company: string;
    displayName: string;
}

export interface IVisitorOnBehalfOfData
{
    firstName: string;
    lastName: string;
    company: string;
    email: string;
    visitorTypeId: string;
}

export interface IOnBehalfOf
{
    email: string;
    firstName: string;
    lastName: string;
    company: string;
    isVisitor: boolean;
    visitorTypeId: string;
}
